import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiArrowUpRight, FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import products from "../data/products";
import "./Products.css";

function Products() {
  const [active, setActive] = useState(null);
  const activeProduct = products.find((p) => p.slug === active);

  return (
    <motion.main
      className="page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <PageHeader
        eyebrow="Our Range"
        title="Six commodities we know <em>by hand and by name.</em>"
        subtitle="Every product here is sourced from a specific growing belt, graded to order, and packed to your market. Tap any card for full specifications."
      />

      <section className="section products-list">
        <div className="container">
          <div className="products-grid">
            {products.map((p, i) => (
              <motion.button
                key={p.slug}
                className="product-tile"
                onClick={() => setActive(p.slug)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
              >
                <div
                  className="product-tile__image"
                  style={{ backgroundColor: p.color + "22" }}
                >
                  <img src={p.image} alt={p.name} />
                  <span className="product-tile__hs">HS {p.hsCode}</span>
                </div>
                <div className="product-tile__body">
                  <div className="product-tile__head">
                    <h3>{p.name}</h3>
                    <span className="product-tile__local">{p.local}</span>
                  </div>
                  <p>{p.tagline}</p>
                  <div className="product-tile__specs">
                    <div>
                      <span className="product-tile__label">Origin</span>
                      <span>{p.origin}</span>
                    </div>
                    <div>
                      <span className="product-tile__label">Purity</span>
                      <span>{p.purity}</span>
                    </div>
                  </div>
                  <span className="product-tile__cta">
                    Full specs <FiArrowUpRight />
                  </span>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
      </section>

      {/* ======= DETAIL MODAL ======= */}
      <AnimatePresence>
        {activeProduct && (
          <motion.div
            className="product-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
          >
            <motion.div
              className="product-modal__inner"
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="product-modal__close"
                onClick={() => setActive(null)}
                aria-label="Close"
              >
                <FiX />
              </button>
              <div className="product-modal__grid">
                <div
                  className="product-modal__image"
                  style={{ backgroundColor: activeProduct.color + "22" }}
                >
                  <img src={activeProduct.image} alt={activeProduct.name} />
                </div>
                <div className="product-modal__body">
                  <span className="eyebrow">{activeProduct.local}</span>
                  <h2>{activeProduct.name}</h2>
                  <p className="product-modal__tag">{activeProduct.tagline}</p>

                  <div className="product-modal__specs">
                    <div>
                      <span>Origin</span>
                      <strong>{activeProduct.origin}</strong>
                    </div>
                    <div>
                      <span>Grade</span>
                      <strong>{activeProduct.grade}</strong>
                    </div>
                    <div>
                      <span>Moisture</span>
                      <strong>{activeProduct.moisture}</strong>
                    </div>
                    <div>
                      <span>Purity</span>
                      <strong>{activeProduct.purity}</strong>
                    </div>
                    <div>
                      <span>Packing</span>
                      <strong>{activeProduct.packing}</strong>
                    </div>
                    <div>
                      <span>HS Code</span>
                      <strong>{activeProduct.hsCode}</strong>
                    </div>
                  </div>

                  <div className="product-modal__uses">
                    <span className="product-modal__uses-label">Applications</span>
                    <ul>
                      {activeProduct.uses.map((u) => (
                        <li key={u}>{u}</li>
                      ))}
                    </ul>
                  </div>

                  <Link
                    to="/contact"
                    className="btn btn-primary"
                    onClick={() => setActive(null)}
                  >
                    Request a quotation <FiArrowUpRight />
                  </Link>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.main>
  );
}

export default Products;
